import { useOrigens } from '../dominio/origens.ts';
import { CadastroPorNome } from './CadastroPorNome.tsx';

/**
 * O cadastro de Origens, da Administradora (NEX-228).
 *
 * O Lead guarda o código da origem, e não o nome: renomear só muda o que as
 * telas, a planilha e a conversão por origem mostram. Reducee, Parceiro e Meta
 * Ads vêm travadas — o sistema depende delas — e só se renomeiam.
 */
export function CadastroDeOrigens(): React.JSX.Element {
  const { todas, pronta } = useOrigens();

  return (
    <CadastroPorNome
      titulo="Origens"
      descricao="Por onde os leads chegam: as opções da nova oportunidade, do cadastro de lead e da importação."
      vocabulario={{
        singular: 'origem',
        plural: 'origens',
        uso: ['Lead', 'Leads'],
        tamanhoMaximo: 60,
      }}
      itens={todas.map((origem) => ({ ...origem, id: origem.codigo, travado: origem.travada }))}
      pronto={pronta}
    />
  );
}
